<template>
  <action-dispatcher
    action="product/getProduct"
    :parameters="$route.params.id"
    class="view-member-area-groups"
  >
    <step-title
      title="Turmas"
      description="Visualização e configuração das suas turmas."
    />

    <div v-if="!groups.length && loading" class="text-center">
      <b-spinner variant="primary" />
    </div>

    <div v-else-if="!groups.length" class="container centering text-center">
      <img
        class="d-block mb-9 mx-auto"
        src="@/assets/images/home/welcome.svg"
      />
      <h5>Bem-vindo(a) a área de membros do seu produto</h5>
      <div class="text-secondary mb-9">
        Para começar, cadastre o primeira turma.
      </div>
      <router-link
        class="btn btn-primary"
        :to="{
          name: 'product-member-area-groups-add',
          params: { id: $route.params.id }
        }"
      >
        Cadastrar Turma
      </router-link>
    </div>

    <template v-else>
      <div class="row justify-content-between mb-3">
        <div class="col-lg-4 mb-5 mb-lg-0">
          <div class="d-flex align-items-center">
            <div class="d-flex flex-column">
              <span class="table-quantity-counter mr-3">
                Total: {{ pagination.count }}
              </span>
            </div>
            <button class="btn p-0 table-refresh" @click="refresh">
              <i class="fa-solid fa-refresh" />
            </button>
          </div>
        </div>
        <div class="col-xl-5 col-lg-6">
          <div class="d-flex justify-content-between mb-3">
            <search-filter
              placeholder="Pesquisar"
              @search="searching"
              class="mb-3 mb-lg-0 flex-fill"
              filterButtonText=""
              :showResultsDropdown="false"
              :newDesign="true"
            >
            </search-filter>
            <router-link
              class="btn btn-sm btn-40 btn-primary px-3 ml-3"
              :to="{
                name: 'product-member-area-groups-add',
                params: {
                  id: $route.params.id
                }
              }"
            >
              <i class="icon-plus pr-5"></i>
              <span class="pr-5">Nova turma</span>
            </router-link>
          </div>
        </div>
      </div>

      <div v-if="loading" class="text-center">
        <b-spinner variant="primary" />
      </div>

      <div class="d-flex flex-column h-100" v-else>
        <data-table
          class="d-none d-lg-block flex-fill"
          :columns="responsive.columns"
          :data="groups"
          :firstColumnFr="1"
          :lastColumnFr="0.5"
          newDesign
        >
          <template #default="{ item }">
            <div class="d-flex align-items-center text-truncate">
              {{ item.name }}
            </div>
            <div class="d-flex align-items-center justify-content-end">
              <actions-dropdown
                :left="false"
                :right="true"
                :actions="responsive.actions"
                @edit="editgroup(item)"
                @remove="removegroup(item)"
              />
            </div>
          </template>
        </data-table>
        <!-- mobile area -->
        <data-table
          class="d-lg-none"
          :columns="responsive.columns.slice(0, 2).map(() => '')"
          :data="groups"
          :firstColumnFr="2"
          :lastColumnFr="0.5"
          newDesign
        >
          <template #default="{ item }">
            <div
              class="d-flex flex-column text-left responsive-bg-secondary-item pl-3 py-5"
            >
              <small class="d-flex align-items-center text-truncate">
                <strong class="mr-3">Nome:</strong>
                {{ item.name }}
              </small>
            </div>
            <div class="d-flex justify-content-end">
              <actions-dropdown
                :left="false"
                :right="true"
                :actions="responsive.actions"
                @edit="editgroup(item)"
                @remove="removegroup(item)"
              />
            </div>
          </template>
        </data-table>
        <!-- mobile area -->
        <div class="d-flex justify-content-end mb-6">
          <paginator :pagination="pagination"></paginator>
        </div>
      </div>
    </template>
  </action-dispatcher>
</template>

<script>
import ProductActionsMixin from "@/mixins/productActions.js";
import { mapState } from "vuex";

export default {
  mixins: [ProductActionsMixin],
  computed: {
    ...mapState("product", ["product"]),
    ...mapState("membersGroups", ["groups", "pagination"]),
    breadcrumbs() {
      return [
        { link: "product", title: "Meus produtos" },
        {
          link: "product-details",
          title: this.product ? this.product["name"] : "...",
          params: { id: this.$route.params.id }
        },
        {
          title: "Turmas"
        }
      ];
    }
  },
  data() {
    return {
      params: {
        product_id: this.$route.params.id,
        offset: 0
      },
      loading: false,
      search: "",
      editedIndex: null,
      responsive: {
        columns: ["Nome da turma", ""],
        actions: [
          {
            text: "Editar turma",
            class: "",
            icon: "fa-solid fa-pen",
            confirmation: {
              enable: false
            },
            event: "edit"
          },
          {
            text: "Remover",
            class: "text-danger",
            icon: "icon-trash",
            confirmation: {
              enable: true,
              text: "Tem certeza que deseja excluir essa turma?",
              newDesign: true,
              submitText: "Excluir",
              submitButtonClass: "btn-danger"
            },
            event: "remove"
          }
        ]
      }
    };
  },
  mounted() {
    this.dispatch();
  },
  methods: {
    onPaginationUpdate(offset) {
      this.params.offset = offset;
      this.refresh();
    },
    editgroup(group) {
      this.$router.push({
        name: "product-member-area-groups-edit",
        params: { group: group.id }
      });
    },
    removegroup(group) {
      this.$store.dispatch("membersGroups/delete", group.id).then(this.refresh);
    },
    searching(v) {
      this.search = v;
    },
    refresh() {
      this.dispatch();
    },
    dispatch() {
      this.loading = true;
      this.$store.dispatch("membersGroups/getAll", this.params).finally(() => {
        this.loading = false;
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.view-member-area-groups {
  flex: 1;
  a {
    text-decoration: none;
  }
  .box {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    border: 1px solid #d2d0d8;
    border-radius: 4px;
    height: 232px;
    cursor: pointer;
    img {
      height: 54px;
      width: 54px;
    }

    &:hover {
      background: linear-gradient(148.5deg, #ee6469 -19.31%, #5576ec 100%);
      border-color: rgb(191, 92, 170);

      strong {
        color: white;
      }
    }
  }
}
</style>
